<section class="article-component-cont">
  <header>
    <h3 class="ent-color"><i class="fas fa-user-clock" aria-hidden="true"></i>Rate lock information</h3>
  </header>
  @if (rateLockInfo()) {
    <div class="article-content rate-lock-info">
      @if (rateLockInfo()?.effectiveDate) {
        <div class="info-row">
          <p class="info-label">Effective date:</p>
          <p class="info-value">{{ rateLockInfo()!.effectiveDate }}</p>
        </div>
      }
      @if (rateLockInfo()?.duration) {
        <div class="info-row">
          <p class="info-label">Duration:</p>
          <p class="info-value">{{ rateLockInfo()!.duration }}</p>
        </div>
      }
      @if (rateLockInfo()?.expirationDate) {
        <div class="info-row">
          <p class="info-label">Expiration date:</p>
          <p class="info-value">{{ rateLockInfo()!.expirationDate }}</p>
        </div>
      }
      @if (rateLockInfo()?.wait30) {
        <div class="info-row">
          <p class="info-label">Wait 30:</p>
          <p class="info-value">{{ rateLockInfo()!.wait30 }}</p>
        </div>
      }
    </div>
  }
</section>
